import { ArrowUpRight, Library } from "lucide-react";
import { Reveal } from "./Reveal";
import { Squiggle, VinylRecord } from "./doodles";

const MIXCLOUD_EMBED =
    "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&feed=%2Fmr1st%2F&utm_medium=share&utm_source=embed&utm_content=profile&utm_term=VXNlcjo2ODQ0NDgx";
const MIXCLOUD_PROFILE = "https://www.mixcloud.com/mr1st/";

export default function LatestEpisodes() {
    return (
        <section
            id="latest-episodes"
            data-testid="latest-episodes-section"
            className="border-b-[2.5px] border-ink bg-mintlight py-16 sm:py-24"
        >
            <div className="mx-auto max-w-4xl px-4 sm:px-6">
                <Reveal className="text-center">
                    <div className="relative mx-auto w-fit">
                        <VinylRecord className="mx-auto h-28 w-28 sm:h-32 sm:w-32" />
                    </div>
                    <span className="sticker mt-6 bg-mint">03 · The Archive</span>
                    <h2 className="mt-4 font-condensed text-3xl font-black uppercase tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        Latest Episodes.
                    </h2>
                    <Squiggle className="mx-auto mt-3 h-3 w-36" stroke="#4EDBA2" />
                    <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-ink2 sm:text-lg">
                        Missed the show? Catch up anytime.
                    </p>
                </Reveal>

                <Reveal delay={0.15} className="mt-10">
                    <div className="rounded-3xl border-[3px] border-ink bg-cream p-4 shadow-[8px_8px_0_#1A1918] sm:p-6">
                        <div className="mb-3 flex items-center gap-2 px-1">
                            <Library className="h-4 w-4 text-ink" strokeWidth={2.5} />
                            <span className="font-mono2 text-xs font-bold uppercase tracking-[0.18em] text-ink2">
                                Mixcloud · @mr1st — full episode feed
                            </span>
                        </div>
                        <iframe
                            data-testid="mixcloud-embed"
                            src={MIXCLOUD_EMBED}
                            title="The Snooze Button — latest episodes on Mixcloud"
                            className="h-[400px] w-full rounded-2xl border-[2.5px] border-ink bg-white"
                            loading="lazy"
                            allow="autoplay"
                        />
                        <p className="mt-3 px-1 font-mono2 text-xs leading-relaxed text-ink2">
                            This feed updates automatically — new uploads appear here on their own.
                        </p>
                    </div>
                    <div className="mt-6 text-center">
                        <a
                            data-testid="mixcloud-profile-link"
                            href={MIXCLOUD_PROFILE}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-ink bg-white text-lg hover:bg-mintlight"
                        >
                            Explore All Episodes
                            <ArrowUpRight className="h-5 w-5" strokeWidth={2.5} />
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
